import { useContext } from "react";
import { SettingsContext } from "../../contexts";

/**
 * Per-store switch for the legacy quote pricing workflow — the PRODUCT PRICING
 * dropdown on order quotes, the visible TRADE / MARKET MEDIAN inputs on sell
 * quotes, and the quote modal's Pricing tab. Served by GET /api/app-settings
 * as `quote_product_pricing` (backend App\Support\QuoteProductPricing). ON for
 * the DAO Watches stores, OFF (simplified) for everyone else by default.
 *
 * Only an explicit `false` turns it off: a missing key (settings not loaded
 * yet, or a backend that predates the flag) keeps today's workflow, so this
 * can never hide anything by accident.
 */
export const quoteProductPricingEnabled = (settings) =>
  settings?.quote_product_pricing !== false;

export const useQuoteProductPricing = () => {
  const { settings } = useContext(SettingsContext) || {};

  return quoteProductPricingEnabled(settings);
};
